import * as React from "react"

const CartIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg"  
    {...props}
  >
    <path d="M19.5 3a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm-.5 7V8h-2V7h2V5l3 2.5-3 2.5zM7.752 8l-.564-2h5.993A6.45 6.45 0 0 0 13 7.5l.025.5H7.752zM14 19.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zM0 3l.743 2h1.929l3.474 12h13.239l1.307-3.114A6.51 6.51 0 0 1 19.5 14a6.59 6.59 0 0 1-.99-.083L18.055 15H7.627L4.195 3H0zm9 16.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0z" />
  </svg>
)

export default CartIcon